<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15XDCEP/tc-custom/9781488092350.jpg?1705237072593" alt="This image is the cover for the book Second Chance, Alaskan Oil Barons"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Second Chance, Alaskan Oil Barons
      </h1>
      <p class="bookDescription body article font2">
        <b>Amnesia gives a rocky marriage a second chance in this contemporary romance by a <i>USA Today</i>–bestselling author.</b><br/><br/>Chuck Mikkelson knows Shana doesn’t remember him . . . or that she wanted a divorce. But now she’s back in his home, and he vows to save their union at all costs. This may be the only second chance he has to win back his wife. Will their rekindled passion be enough to convince her to stay when her memory returns?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Catherine Mann
      </h2>
      
      <p class="authorDescription body article"><I>USA TODAY</I> bestselling author&#160;Catherine Mann has books in print in more than 20 countries with Harlequin Desire, Harlequin Romantic Suspense, HQN and other imprints. A six-time RITA finalist, she has won both a RITA and Romantic Times Reviewer&#39;s Choice Award. Mother of four, Catherine&#160;lives in South Carolina where she enjoys kayaking, hiking with her dog and volunteering in animal rescue. FMI, visit: <a href="http://catherinemann.com">catherinemann.com</a>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?308ee267